import { formatToArray } from "owa-localize";
import { getLocalizedString } from "owa-datetime-formatters-core";

export default function formatWeekRangeWeekNumber(weekRangeElement: React.JSX.Element, weekNumber: number): (string | React.JSX.Element)[] {
    return formatToArray(getLocalizedString("weekRangeWeekNumber"), weekRangeElement, weekNumber.toString());
}
